export default __webpack_public_path__ + "static/media/search_icon.3fed9988.svg";